import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import Swal from '../../plugins/sweetalert';
import VueFilter from 'vue-filter';
import Mint from 'mint-ui';
import 'mint-ui/lib/style.css'

Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(Swal);
Vue.use(VueFilter);
Vue.use(Mint);


//style
import '../../assets/css/bootstrap.css'
import '../../assets/css/font-awesome.css'
import '../../assets/css/animate.css'
import '../../assets/css/keyboard.css'
import '../../assets/css/style.css'
import '../../assets/js/plugins/datapicker/datepicker3.css';
import '../../assets/js/plugins/datapicker/bootstrap-datetimepicker.css';


import authInterceptor from '../../interceptors/auth_interceptor';
authInterceptor(Vue);
import registerComponent from '../../components/registerComponent';
registerComponent(Vue);
import { DatetimePicker } from 'mint-ui';
Vue.component(DatetimePicker.name, DatetimePicker);
//js
import '../../assets/js/bootstrap'
import '../../assets/js/keyboard'
import '../../assets/js/fastclick.min-1.0.6'
import '../../assets/js/share'
import '../../assets/js/jquery.qrcode.min'
import '../../assets/js/plugins/datapicker/bootstrap-datepicker';
import '../../assets/js/plugins/datapicker/bootstrap-datetimepicker';


//引入组件
import App from './App'
import Main from './views/Main.vue'
import Gowhere from './views/gowhere.vue'
import Card_qrcode from './views/card_qrcode.vue'
import Card_choose from './views/card_choose.vue'
import Card_online from './views/card_online.vue'
import Card_bind from './views/card_bind.vue'
import Login from './views/login.vue'
import LoginPage from './views/loginPage.vue'
import Recharge from './views/recharge.vue'
import Setup from './views/setup.vue'
import Bill from './views/bill.vue'


// 创建路由实例 定义路由配置
const router = new VueRouter({
  routes : [
    {path:'/main', component:Main},
    {path:'/gowhere', component:Gowhere},
    {path:'/card_qrcode',component:Card_qrcode},
    {path:'/card_choose',component:Card_choose},
    {path:'/card_bind',component:Card_bind},
    {path:'/card_online',component:Card_online},
    {path:'/recharge',component:Recharge},
    {path:'/setup',component:Setup},
    {path:'/bill',component:Bill},
    {path:'/login', component:Login},
    {path:'/loginPage', component:LoginPage},
    // {path: '/', redirect: '/loginPage'}
  ]
});

window.router = router;

new Vue({
  router,
  template: '<App/>',
  components: {
    App
  },
  data: {
    eventHub: new Vue()
  }
}).$mount('#app');
// router.push('main');



// WEBPACK FOOTER //
// ./src/module/main/main.js